const getAccessPoint = (state) => state?.callCenter?.accessPoint || {};

export { getAccessPoint };
